/* =====================================================================
   EurekaPAES Buscador — Módulo Estrategia v6
   Plan de ataque · Análisis por prueba · Ranking alcanzables · 
   Distancia mínima al sueño · What-if ampliado
   Expone window.EpEstrategia.{...}
   ===================================================================== */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
      var v = attrs[k];
      if (v == null || v === false) continue;
      if (k === 'class') n.className = v;
      else if (k === 'text') n.textContent = v;
      else if (k === 'html') n.innerHTML = v;
      else if (k.indexOf('on') === 0 && typeof v === 'function') n.addEventListener(k.substring(2), v);
      else n.setAttribute(k, v);
    }
    if (children) {
      if (!Array.isArray(children)) children = [children];
      children.forEach(function (c) {
        if (c == null || c === false) return;
        if (typeof c === 'string') n.appendChild(document.createTextNode(c));
        else n.appendChild(c);
      });
    }
    return n;
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/`/g, '&#96;');
  }
  function fmt(p) {
    if (p == null) return '—';
    return (typeof p === 'number' && p % 1 !== 0) ? p.toFixed(1) : String(p);
  }
  function dataArr() { return (window.EP_PAES_DATA && Array.isArray(window.EP_PAES_DATA)) ? window.EP_PAES_DATA : []; }
  function findByCode(cod) { var a = dataArr(); for (var i = 0; i < a.length; i++) if (a[i].codigo_demre === cod) return a[i]; return null; }
  function readJSON(k, def) { try { return JSON.parse(localStorage.getItem(k)) || def; } catch (e) { return def; } }
  function getPuntajes() { return readJSON('ep_paes_puntajes_v1', {}); }
  function getFavs() { return readJSON('ep_paes_favs_v1', []).map(findByCode).filter(Boolean); }
  var PRUEBAS_KEYS = ['nem','ranking','competencia_lectora','matematica_m1','matematica_m2','ciencias','historia'];
  var LABELS = {nem:'NEM',ranking:'Ranking',competencia_lectora:'Competencia Lectora',matematica_m1:'Matemática M1',matematica_m2:'Matemática M2',ciencias:'Ciencias',historia:'Historia y CC. Sociales'};
  var CORTOS = {nem:'NEM',ranking:'Ranking',competencia_lectora:'CLEC',matematica_m1:'M1',matematica_m2:'M2',ciencias:'Ciencias',historia:'Historia'};

  /* Cálculo de ponderado respetando electiva */
  function computePond(c, puntajes) {
    var pond = c.ponderaciones || {};
    var keys = Object.keys(pond).filter(function (k) { return pond[k] > 0; });
    if (keys.length === 0) return null;
    var electiva = !!c.electiva_ciencias_historia;
    var faltan = [];
    keys.forEach(function (k) { if (puntajes[k] == null || isNaN(puntajes[k])) faltan.push(k); });
    if (electiva) {
      var hC = puntajes.ciencias != null, hH = puntajes.historia != null;
      faltan = faltan.filter(function (k) { return k !== 'ciencias' && k !== 'historia'; });
      if (!hC && !hH) return null;
    }
    if (faltan.length > 0) return null;
    var total = 0;
    if (electiva) {
      var pct = pond.ciencias;
      var aC = puntajes.ciencias != null ? puntajes.ciencias * (pct / 100) : -Infinity;
      var aH = puntajes.historia != null ? puntajes.historia * (pct / 100) : -Infinity;
      total += Math.max(aC, aH);
    }
    keys.forEach(function (k) {
      if (electiva && (k === 'ciencias' || k === 'historia')) return;
      total += puntajes[k] * (pond[k] / 100);
    });
    return Math.round(total * 10) / 10;
  }
  function getMeta(c) { return c.ponderado_ultimo_matriculado != null ? c.ponderado_ultimo_matriculado : c.puntaje_corte_clec_m1; }

  /* ============ ANÁLISIS POR PRUEBA ============
     Prioridad PRINCIPAL: PROMEDIO de ponderación (%) entre favoritas que la incluyen.
     Empate 1: pondCount (en cuántas favoritas aparece).
     Empate 2: gap (1000 - mi puntaje). */
  function analisisPruebas() {
    var puntajes = getPuntajes();
    var favs = getFavs();
    var hasPuntajes = Object.keys(puntajes).length > 0;
    var res = {};
    PRUEBAS_KEYS.forEach(function (k) {
      res[k] = {
        key: k, label: LABELS[k], corto: CORTOS[k],
        pondTotal: 0, pondCount: 0,
        miPunt: puntajes[k] != null ? puntajes[k] : null,
        pondPromedio: 0,
        gap: 0,
        deltaAvgPond: 0
      };
    });
    favs.forEach(function (c) {
      var p = c.ponderaciones || {};
      PRUEBAS_KEYS.forEach(function (k) {
        var pct = p[k] || 0;
        if (pct === 0) return;
        res[k].pondTotal += pct;
        res[k].pondCount++;
      });
    });
    PRUEBAS_KEYS.forEach(function (k) {
      if (res[k].pondCount > 0) {
        res[k].pondPromedio = Math.round((res[k].pondTotal / res[k].pondCount) * 10) / 10;
      }
      res[k].gap = res[k].miPunt != null ? Math.max(0, 1000 - res[k].miPunt) : 500;
      /* Impacto de subir +50 en esa prueba: pondPromedio% × 50 puntos */
      res[k].deltaAvgPond = Math.round((res[k].pondPromedio * 0.5) * 10) / 10;
    });
    var arr = PRUEBAS_KEYS.map(function (k) { return res[k]; });
    arr.sort(function (a, b) {
      if (b.pondPromedio !== a.pondPromedio) return b.pondPromedio - a.pondPromedio;
      if (b.pondCount !== a.pondCount) return b.pondCount - a.pondCount;
      return b.gap - a.gap;
    });
    return { arr: arr, hasPuntajes: hasPuntajes, favsCount: favs.length };
  }

  /* ============ PLAN DE ATAQUE (sección visual) ============ */
  function renderPlanAtaque() {
    var info = analisisPruebas();
    if (info.favsCount === 0) return null;
    var topPrueba = info.arr.filter(function (p) { return p.pondCount > 0; })[0];
    if (!topPrueba) return null;
    var box = el('div', { class: 'ep-paes-plan' });
    box.appendChild(el('h3', { class: 'ep-paes-plan-title', html: '🎯 Mi plan de ataque PAES' }));
    box.appendChild(el('p', { class: 'ep-paes-plan-sub', html:
      'Tu prueba prioritaria es <strong>' + escapeHtml(topPrueba.label) + '</strong>: aparece en ' +
      '<strong>' + topPrueba.pondCount + ' de ' + info.favsCount + '</strong> favoritas y tiene una ' +
      '<strong>ponderación promedio de ' + topPrueba.pondPromedio + '%</strong>.'
    }));

    /* Simulación +25/+50/+100 */
    var simBox = el('div', { class: 'ep-paes-plan-sim' });
    [25, 50, 100].forEach(function (boost) {
      var avgDelta = 0, count = 0;
      getFavs().forEach(function (c) {
        var p = c.ponderaciones || {};
        var pct = p[topPrueba.key] || 0;
        if (pct === 0) return;
        avgDelta += boost * (pct / 100);
        count++;
      });
      avgDelta = count > 0 ? Math.round((avgDelta / count) * 10) / 10 : 0;
      simBox.appendChild(el('div', { class: 'ep-paes-plan-sim-cell' }, [
        el('div', { class: 'lbl', text: '+' + boost + ' pts en ' + topPrueba.corto }),
        el('div', { class: 'val', text: '+' + avgDelta + ' pond. prom.' })
      ]));
    });
    box.appendChild(simBox);

    /* CTA EurekaPAES */
    box.appendChild(el('div', { class: 'ep-paes-plan-cta', html:
      'En <strong>EurekaPAES</strong> puedes reforzar ' + escapeHtml(topPrueba.label) + ' con cápsulas grabadas, guías tipo PAES y solucionarios paso a paso.'
    }));
    box.appendChild(el('a', {
      href: 'https://www.eurekapaes.cl/collections/preu',
      target: '_blank', rel: 'noopener noreferrer',
      class: 'ep-paes-plan-btn',
      html: '🚀 Reforzar con EurekaPAES'
    }));
    return box;
  }

  /* ============ ANÁLISIS POR PRUEBA (panel con barras) ============
     Barra principal = pondPromedio (importancia promedio en tus favoritas) */
  function renderAnalisisPruebas() {
    var info = analisisPruebas();
    if (info.favsCount === 0) return null;
    var visibles = info.arr.filter(function (p) { return p.pondCount > 0; });
    if (!visibles.length) return null;
    var maxPond = Math.max.apply(Math, visibles.map(function (p) { return p.pondPromedio; }));
    var box = el('div', { class: 'ep-paes-analisis' });
    box.appendChild(el('h3', { class: 'ep-paes-analisis-title', html: '📊 ¿Qué prueba te conviene reforzar?' }));
    box.appendChild(el('p', { class: 'ep-paes-analisis-sub', text: 'Ordenadas por su importancia promedio en tus favoritas. Mientras más alta la barra, más pesa esa prueba para alcanzar tus carreras.' }));
    var list = el('div', { class: 'ep-paes-analisis-list' });
    visibles.forEach(function (p) {
      var pctBar = Math.max(4, Math.round((p.pondPromedio / maxPond) * 100));
      var row = el('div', { class: 'ep-paes-analisis-row' });
      var head = el('div', { class: 'ep-paes-analisis-head' });
      head.appendChild(el('span', { class: 'lbl', text: p.label }));
      head.appendChild(el('span', { class: 'meta' }, [
        el('span', { class: 'badge-pond', html: 'Pond. promedio: <strong>' + p.pondPromedio + '%</strong>' }),
        el('span', { class: 'count', text: 'en ' + p.pondCount + ' de ' + info.favsCount + ' favoritas' }),
        (p.miPunt != null ? el('span', { class: 'tu', text: 'tu puntaje: ' + p.miPunt }) : null)
      ]));
      row.appendChild(head);
      row.appendChild(el('div', { class: 'ep-paes-analisis-bar' }, [el('i', { style: 'width:' + pctBar + '%' })]));
      if (p.deltaAvgPond > 0) {
        row.appendChild(el('div', { class: 'ep-paes-analisis-delta', text: '+50 pts en ' + p.corto + ' → +' + p.deltaAvgPond + ' al ponderado promedio' }));
      }
      list.appendChild(row);
    });
    box.appendChild(list);
    return box;
  }

  /* ============ RANKING DE CARRERAS ALCANZABLES ============ */
  function calcularRanking() {
    var puntajes = getPuntajes();
    if (Object.keys(puntajes).length < 3) return null;
    var all = dataArr();
    if (!all.length) return null;
    var rows = [];
    all.forEach(function (c) {
      var pond = computePond(c, puntajes);
      var meta = getMeta(c);
      if (pond == null || meta == null) return;
      var diff = Math.round((meta - pond) * 10) / 10;
      rows.push({ c: c, pond: pond, meta: meta, diff: diff });
    });
    rows.sort(function (a, b) { return a.diff - b.diff; });
    return rows;
  }
  function renderRanking() {
    var rows = calcularRanking();
    if (rows == null) {
      return el('div', { class: 'ep-paes-ranking-hint', text: 'Ingresa tus puntajes globales para activar el ranking.' });
    }
    var box = el('div', { class: 'ep-paes-ranking' });
    box.appendChild(el('h3', { class: 'ep-paes-ranking-title', html: '🏆 Carreras más alcanzables para ti' }));
    box.appendChild(el('p', { class: 'ep-paes-ranking-sub', text: 'Top 30 carreras ordenadas por cercanía con tu puntaje actual. Las primeras ya las alcanzas; las siguientes son donde menos te falta.' }));
    var top = rows.slice(0, 30);
    var list = el('div', { class: 'ep-paes-ranking-list' });
    top.forEach(function (r, i) {
      var estCls = r.diff <= 0 ? 'sobre' : (r.diff <= 30 ? 'cerca' : (r.diff <= 80 ? 'camino' : 'reforz'));
      var card = el('div', { class: 'ep-paes-ranking-row is-' + estCls });
      card.appendChild(el('div', { class: 'pos', text: '#' + (i + 1) }));
      card.appendChild(el('div', { class: 'info' }, [
        el('div', { class: 'tit', text: r.c.carrera }),
        el('div', { class: 'uni', text: r.c.universidad }),
        el('div', { class: 'meta', text: '#' + r.c.codigo_demre + (r.c.region ? ' · ' + r.c.region : '') + (r.c.area ? ' · ' + r.c.area : '') })
      ]));
      card.appendChild(el('div', { class: 'pts' }, [
        el('div', { class: 'val', text: r.diff <= 0 ? '+' + Math.abs(r.diff) : r.diff }),
        el('div', { class: 'lbl', text: r.diff <= 0 ? 'sobre' : 'te faltan' })
      ]));
      card.appendChild(el('button', {
        type: 'button', class: 'ep-paes-ranking-btn', text: 'Ver →',
        onclick: function () { if (window.EpPaesAbrirModal) window.EpPaesAbrirModal(r.c); }
      }));
      list.appendChild(card);
    });
    box.appendChild(list);
    if (rows.length > 30) {
      box.appendChild(el('div', { class: 'ep-paes-ranking-foot', text: 'Mostrando 30 de ' + rows.length + ' carreras con datos suficientes para calcular tu ponderado.' }));
    }
    return box;
  }

  /* ============ DISTANCIA MÍNIMA AL SUEÑO (modal) ============ */
  function renderDistancia(carrera) {
    var puntajes = getPuntajes();
    var pond = computePond(carrera, puntajes);
    var meta = getMeta(carrera);
    if (pond == null || meta == null) return null;
    var diff = Math.round((meta - pond) * 10) / 10;
    if (diff <= 0) {
      return el('div', { class: 'ep-paes-distancia is-sobre', html:
        '🎉 <strong>¡Buenas noticias!</strong> Con tus puntajes actuales ya estás <strong>' + Math.abs(diff) + ' puntos sobre</strong> esta carrera. Recuerda que la meta puede variar cada año.'
      });
    }
    /* Buscar pruebas ponderadas con mejor margen para subir */
    var p = carrera.ponderaciones || {};
    var keys = Object.keys(p).filter(function (k) { return p[k] > 0; });
    var subidas = [];
    keys.forEach(function (k) {
      var miPunt = puntajes[k];
      if (miPunt == null) return;
      var maxSubida = Math.min(150, 1000 - miPunt);
      if (maxSubida <= 0) return;
      var necesario = Math.ceil((diff / (p[k] / 100)) * 10) / 10;
      if (necesario <= maxSubida) {
        subidas.push({ key: k, label: LABELS[k], corto: CORTOS[k], pct: p[k], necesario: necesario, actual: miPunt });
      }
    });
    var box = el('div', { class: 'ep-paes-distancia' });
    box.appendChild(el('h4', { class: 'ep-paes-modal-h4', html: '<span>📐</span> ¿Qué necesito subir para alcanzar esta carrera?' }));
    box.appendChild(el('p', { class: 'ep-paes-distancia-sub', html: 'Te faltan <strong>' + diff + ' puntos ponderados</strong>. Aquí van algunas combinaciones posibles:' }));
    if (subidas.length === 0) {
      box.appendChild(el('p', { class: 'ep-paes-distancia-empty', text: 'La meta requiere subir varias pruebas en conjunto. Te recomendamos enfocar primero en las pruebas con mayor ponderación.' }));
    } else {
      subidas.sort(function (a, b) { return a.necesario - b.necesario; });
      var list = el('ul', { class: 'ep-paes-distancia-list' });
      subidas.slice(0, 4).forEach(function (s) {
        list.appendChild(el('li', { html:
          '<strong>Opción:</strong> subir ' + escapeHtml(s.label) + ' en <strong>+' + s.necesario + ' puntos</strong> (de ' + s.actual + ' a ' + (s.actual + s.necesario).toFixed(0) + ').'
        }));
      });
      /* Combinación 2 pruebas */
      if (subidas.length >= 2) {
        var a = subidas[0], b = subidas[1];
        var mitad = Math.ceil(diff / 2);
        var sa = Math.ceil((mitad / (a.pct / 100)) * 10) / 10;
        var sb = Math.ceil((mitad / (b.pct / 100)) * 10) / 10;
        if (sa + a.actual <= 1000 && sb + b.actual <= 1000) {
          list.appendChild(el('li', { html:
            '<strong>Combinación:</strong> subir ' + escapeHtml(a.label) + ' +' + sa + ' y ' + escapeHtml(b.label) + ' +' + sb + ' pts.'
          }));
        }
      }
      box.appendChild(list);
    }
    return box;
  }

  /* ============ WHAT-IF AMPLIADO (selector de prueba + boost) ============ */
  function renderWhatIfAmpliado(carrera) {
    var pond = carrera.ponderaciones || {};
    var keys = Object.keys(pond).filter(function (k) { return pond[k] > 0; });
    if (keys.length === 0) return null;
    var puntajes = getPuntajes();
    if (Object.keys(puntajes).length === 0) return null;

    var state = { prueba: keys[0], boost: 0 };
    var box = el('div', { class: 'ep-paes-whatif-amp' });
    box.appendChild(el('h4', { class: 'ep-paes-modal-h4', html: '<span>🚀</span> ¿Qué pasa si subo una prueba?' }));
    var ctrl = el('div', { class: 'ep-paes-whatif-amp-ctrl' });
    /* Selector de prueba */
    var sel = el('select', { class: 'ep-paes-whatif-amp-select', 'aria-label': 'Prueba' });
    keys.forEach(function (k) {
      sel.appendChild(el('option', { value: k, text: LABELS[k] + ' (' + pond[k] + '%)' }));
    });
    sel.addEventListener('change', function () { state.prueba = sel.value; render(); });
    ctrl.appendChild(sel);
    /* Botones boost */
    var btnsBox = el('div', { class: 'ep-paes-whatif-amp-btns' });
    [10, 25, 50, 100].forEach(function (b) {
      btnsBox.appendChild(el('button', {
        type: 'button',
        class: 'ep-paes-whatif-amp-btn',
        text: '+' + b,
        onclick: function () { state.boost = state.boost === b ? 0 : b; render(); }
      }));
    });
    ctrl.appendChild(btnsBox);
    box.appendChild(ctrl);

    var resultBox = el('div', { class: 'ep-paes-whatif-amp-result' });
    box.appendChild(resultBox);

    function render() {
      /* Actualizar visual de botones activos */
      var btns = btnsBox.querySelectorAll('.ep-paes-whatif-amp-btn');
      Array.prototype.forEach.call(btns, function (b, i) {
        var val = [10,25,50,100][i];
        b.classList.toggle('is-active', state.boost === val);
      });
      if (state.boost === 0) {
        resultBox.innerHTML = '<div class="ep-paes-whatif-amp-hint">Selecciona una prueba arriba y toca +10/+25/+50/+100 para simular.</div>';
        return;
      }
      var puntajes = getPuntajes();
      var miPunt = puntajes[state.prueba];
      if (miPunt == null) {
        resultBox.innerHTML = '<div class="ep-paes-whatif-amp-hint">⚠️ Ingresa primero tu puntaje en ' + escapeHtml(LABELS[state.prueba]) + ' en "Mis puntajes" globales.</div>';
        return;
      }
      var newPunt = Math.min(1000, miPunt + state.boost);
      var actualBoost = newPunt - miPunt;
      var puntajesNuevos = {};
      for (var k in puntajes) puntajesNuevos[k] = puntajes[k];
      puntajesNuevos[state.prueba] = newPunt;
      var pondActual = computePond(carrera, puntajes);
      var pondNuevo = computePond(carrera, puntajesNuevos);
      if (pondActual == null || pondNuevo == null) {
        resultBox.innerHTML = '<div class="ep-paes-whatif-amp-hint">Faltan más puntajes para calcular el ponderado completo.</div>';
        return;
      }
      var delta = Math.round((pondNuevo - pondActual) * 10) / 10;
      var meta = getMeta(carrera);
      var dif = meta != null ? Math.round((meta - pondNuevo) * 10) / 10 : null;
      resultBox.innerHTML =
        '<div class="ep-paes-whatif-amp-row"><span class="lbl">Subir ' + escapeHtml(LABELS[state.prueba]) + '</span><span class="val">' + miPunt + ' → ' + newPunt + ' (+' + actualBoost + ')</span></div>' +
        '<div class="ep-paes-whatif-amp-row"><span class="lbl">Tu ponderado</span><span class="val">' + pondActual + ' → <strong>' + pondNuevo + '</strong> (+' + delta + ')</span></div>' +
        (meta != null ?
          '<div class="ep-paes-whatif-amp-row"><span class="lbl">Distancia a la meta (' + fmt(meta) + ')</span><span class="val">' +
            (dif <= 0 ? '✅ <strong>Sobre la meta por ' + Math.abs(dif) + ' pts</strong>' : 'Te faltan <strong>' + dif + ' pts</strong>') + '</span></div>'
          : ''
        );
    }
    render();
    return box;
  }

  /* ============ EXPORT ============ */
  window.EpEstrategia = {
    renderPlanAtaque: renderPlanAtaque,
    renderAnalisisPruebas: renderAnalisisPruebas,
    renderRanking: renderRanking,
    renderDistancia: renderDistancia,
    renderWhatIfAmpliado: renderWhatIfAmpliado,
    computePond: computePond,
    analisisPruebas: analisisPruebas
  };
})();
